import AzmoonList from "../../component/azmoon-list/AzmoonList";
import MobileExamsList from "../../component/mobile/azmoon-list/M_ExamsList";

const AsmoonListView = () => {
  return (
    <div className="AZMOON_LIST">
      {window.innerWidth > 1000 && <AzmoonList />}
      {window.innerWidth < 1000 && <MobileExamsList />}
    </div>
  );
};

export default AsmoonListView;
